// System Admin request notifications → tag shown in lists + the Users page panel that handles them.
export const REQUEST_TAGS = {
  coach_deletion_request: { label: "Data deletion request", cls: "bg-amber-100 text-amber-800", panel: "deletion" },
  deletion_activation_request: { label: "Data deletion request", cls: "bg-amber-100 text-amber-800", panel: "deletion" },
  deletion_request: { label: "Data deletion request", cls: "bg-amber-100 text-amber-800", panel: "deletion" },
  role_request: { label: "Role change request", cls: "bg-violet-100 text-violet-800", panel: "roles" },
};

export const requestTag = (n, role) => (role === "administrator" ? REQUEST_TAGS[n.type] : null);
export const requestLink = (n) => `/admin/accounts?panel=${REQUEST_TAGS[n.type]?.panel || "deletion"}`;
export const refreshBadges = () => window.dispatchEvent(new Event("rpg:badges-refresh"));
const NOTIF_BASE = { administrator: "/admin", coach: "/coach", team_member: "/member", parent: "/parent",
  district_administrator: "/staff", campus_administrator: "/staff" };
export const notifBase = (role) => NOTIF_BASE[role] || "/member";
// Coaches: every Rally Books (ledger) notification opens the Team Member Book tab (credit notices open the Fundraising Book).
export const notifLink = (n, role) => (role === "coach" && (n.type || "").startsWith("ledger_") && n.type !== "ledger_credit_notice" ? "/coach/ledger?tab=member" : n.link);

export const timeAgo = (iso) => {
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};
